import { z } from "zod";
import { insertQuoteRequestSchema, insertContactMessageSchema } from "../../shared/schema";

export const quoteFormSchema = insertQuoteRequestSchema.extend({
  terms: z.boolean().refine((val) => val === true, {
    message: "You must agree to the terms and conditions",
  }),
});

export const contactFormSchema = insertContactMessageSchema;

export type QuoteFormValues = z.infer<typeof quoteFormSchema>;
export type ContactFormValues = z.infer<typeof contactFormSchema>;
